import api from '../api';

export const securityDocumentsAPI = {
  // Get all documents with optional search filter and pagination
  getDocuments: async (search?: string, page: number = 1, limit: number = 10, folderId?: number | null) => {
    const params = new URLSearchParams();
    if (search) params.append('search', search);
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (folderId === null) {
      params.append('folder_id', 'null');
    } else if (folderId) {
      params.append('folder_id', folderId.toString());
    }
    const response = await api.get(`/api/security-documents?${params.toString()}`);
    return response.data;
  },

  // Upload new document
  uploadDocument: async (formData: FormData) => {
    const response = await api.post('/api/security-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Download single document
  downloadDocument: async (id: number, filename: string) => {
    const response = await api.get(`/api/security-documents/${id}/download`, {
      responseType: 'blob'
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Bulk download multiple documents as ZIP
  bulkDownload: async (documentIds: number[]) => {
    const response = await api.post(
      '/api/security-documents/bulk-download',
      { documentIds },
      { responseType: 'blob' }
    );

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const timestamp = new Date().toISOString().split('T')[0];
    link.setAttribute('download', `security-documents-${timestamp}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Delete document
  deleteDocument: async (id: number) => {
    const response = await api.delete(`/api/security-documents/${id}`);
    return response.data;
  },

  // ========== FOLDER OPERATIONS ==========

  // Get all folders
  getFolders: async () => {
    const response = await api.get('/api/security-documents/folders');
    return response.data;
  },

  // Create new folder
  createFolder: async (name: string, description?: string, icon?: string) => {
    const response = await api.post('/api/security-documents/folders', {
      name,
      description,
      icon
    });
    return response.data;
  },

  // Update folder
  updateFolder: async (id: number, data: { name: string; description?: string }) => {
    const response = await api.put(`/api/security-documents/folders/${id}`, data);
    return response.data;
  },

  // Delete folder
  deleteFolder: async (id: number) => {
    const response = await api.delete(`/api/security-documents/folders/${id}`);
    return response.data;
  }
};

export default securityDocumentsAPI;
